

























import { Vue, Prop, Component } from 'vue-property-decorator'

import Checkbox from '@/components/Checkbox.vue'
import TransferwisePaymentBody from '@/components/modals/TransferwisePaymentBody.vue'

@Component({
  components: {
    Checkbox,
    TransferwisePaymentBody,
  },
})
export default class EnrollTabBankPayment extends Vue {
  @Prop() termsAccepted!: boolean
  @Prop() paymentCode!: string
  @Prop() transferwiseTemplate!: string
}
